import { gql } from "@apollo/client";

export const InfrastructureSelectRootNodeList = gql`
    query InfrastructureSelectRootNodeList($search: SearchInput, $filter: InstalledBaseNodeListFilter, $pagination: Pagination) {
        installedBaseRootNodeList(filter: $filter, search: $search) {
            total
            installedBaseNodes(pagination: $pagination) {
                id
                key
                title
                assetCount
                childrenNodeCount
                owner {
                    id
                    name
                }
                nodeType {
                    id
                    key
                    name
                }
                pathNodes {
                    id
                    title
                }
            }
        }
    }
`;
